import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "../image/image.component";
import { i18n } from "../return-to-checkout-modal.component";
import styles from "../return-to-checkout-modal.module.css";
import { useReturnToCheckoutModalTracking } from "../return-to-checkout-modal.tracking";
import { Text } from "@cinch-labs/design-system";
import { currencyValueFormatter, LinkToProductDetail } from "@cinch-labs/shared-util";
export var VehicleInformation = function(param) {
    var vehicle = param.vehicle, hidePrice = param.hidePrice, _grayscale = param.grayscale, grayscale = _grayscale === void 0 ? false : _grayscale, adminFeeFlag = param.adminFeeFlag, adminFeeValueInPence = param.adminFeeValueInPence, trackEvent = param.trackEvent, noOpTracking = param.noOpTracking;
    var clickModalVehicleImage = useReturnToCheckoutModalTracking(trackEvent !== null && trackEvent !== void 0 ? trackEvent : noOpTracking).clickModalVehicleImage;
    var imageUrl = vehicle.imageUrl, make = vehicle.make, model = vehicle.model, derivative = vehicle.derivative, priceInPence = vehicle.priceInPence, id = vehicle.id;
    var vehicleName = "".concat(make, " ").concat(model);
    var basicVehicleInfo = {
        make: make,
        model: model,
        id: id
    };
    var vehicleImageStyles = grayscale ? "vehicleImageTransparent" : "vehicleImage";
    var vehicleInfoContainerStyles = grayscale ? styles.vehicleInfoContainerTransparent : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        className: vehicleInfoContainerStyles,
        children: [
            /*#__PURE__*/ _jsx(LinkToProductDetail, {
                basicVehicleInfo: basicVehicleInfo,
                children: /*#__PURE__*/ _jsx(Image, {
                    className: styles[vehicleImageStyles],
                    src: imageUrl,
                    alt: vehicleName,
                    isLazy: true,
                    "aria-hidden": true,
                    onClick: clickModalVehicleImage
                })
            }),
            /*#__PURE__*/ _jsxs(LinkToProductDetail, {
                basicVehicleInfo: basicVehicleInfo,
                className: styles.underlineText,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        fontSizeFixed: "m",
                        fontWeight: "semibold",
                        children: vehicleName
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        fontSizeFixed: "xs",
                        fontWeight: "light",
                        children: "".concat(derivative)
                    })
                ]
            }),
            !hidePrice && /*#__PURE__*/ _jsxs("div", {
                className: styles.priceWrapper,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.price,
                        fontSize: "m",
                        fontWeight: "semibold",
                        children: currencyValueFormatter(priceInPence, true)
                    }),
                    adminFeeFlag && adminFeeValueInPence && /*#__PURE__*/ _jsx(Text, {
                        className: styles.adminFee,
                        fontSize: "s",
                        children: i18n.adminFee.replace("{adminFeeValue}", currencyValueFormatter(adminFeeValueInPence, true))
                    })
                ]
            })
        ]
    });
};
